import { render } from "./Page5Component.vue?vue&type=template&id=2a0d55d0"
import script from "./Page5Component.vue?vue&type=script&lang=js"
export * from "./Page5Component.vue?vue&type=script&lang=js"

import "./Page5Component.vue?vue&type=style&index=0&id=2a0d55d0&lang=scss"

import exportComponent from "C:\\Users\\grego\\Documents\\Projets_info\\New-project\\gregoire-aimier-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__